import { render, staticRenderFns } from "./SingleCmsPage.vue?vue&type=template&id=7d1e2fc9&scoped=true"
import script from "./SingleCmsPage.vue?vue&type=script&lang=js"
export * from "./SingleCmsPage.vue?vue&type=script&lang=js"
import style0 from "./SingleCmsPage.vue?vue&type=style&index=0&id=7d1e2fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1e2fc9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
